const apiKey = process.env.GOOGLE_FONTS_API_KEY;

export const fetchTopGoogleFonts = async (): Promise<any[]> => {
  try {
    const response = await fetch(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}&sort=popularity`
    );
    const data = await response.json();
    // Ca sa cauti un font:
    // const press2StartFont = data.items.find((item: any) => item.family === "Press Start 2P");
    // console.log(press2StartFont);
    if (data && data.items) {
      const fonts = data.items.map((item: any) => ({
        Name: item.family,
        Regular: item.variants.includes("regular") ? item.files.regular : item.variants[0],
        Bold: item.variants.includes("700") ? item.files["700"] : null,
        Italic: item.variants.includes("italic") ? item.files.italic : null,
        BoldItalic: item.variants.includes("700italic") ? item.files["700italic"] : null,
      }));
      
      return fonts;
    } else {
      console.error("Failed to load fonts from Google Fonts API");
      return [];
    }
  } catch (error) {
    console.error("Error fetching Google Fonts:", error);
    return [];
  }
};
